import type {Extension} from '@wix/document-manager-core'
import _ from 'lodash'
import {CSaveApi, CS_EVENTS, CSaveTestApi} from './continuousSave'
import type {GetTransactionsResponse, GetDocumentResponse} from './serverProtocolTypes'

const asyncNoop = async () => undefined

export class EmptyCSaveExt implements Extension {
    readonly name: string = 'continuousSave'
    readonly EVENTS: Record<string, any> = CS_EVENTS
    readonly dependencies = new Set(['schema'])
    createExtensionAPI(): CSaveApi {
        return {
            continuousSave: {
                createRevision: async () => ({
                    actions: [],
                    siteRevision: {
                        revision: 1,
                        version: 1
                    }
                }),
                getPagesAddedInRevision: async () => [],
                getPagesRemovedInRevision: async () => [],
                save: asyncNoop,
                saveAndWaitForResult: asyncNoop,
                forceSaveAndWaitForResult: asyncNoop,
                initCSave: async () => false,
                deleteTx: asyncNoop,
                setSaving: _.noop,
                getLastTransactionId: () => undefined,
                getLastSaveDate: async () => undefined,
                initHooks: _.noop,
                getWrappedHooks: () => ({}),
                setEnabled: _.noop,
                shouldSave: () => false,
                getTransactions: async (): Promise<GetTransactionsResponse> => ({transactions: []}),
                getTransactionsFromLastRevision: async (): Promise<GetTransactionsResponse> => ({transactions: []}),
                getStore: async (): Promise<GetDocumentResponse> => ({
                    actions: [],
                    firstTransactionId: '',
                    lastTransactionId: ''
                }),
                approveForeignTransaction: asyncNoop,
                isCSaveOpen: () => false,
                isCEditOpen: () => false,
                disableSaveDuringRequiredAndPrimary: () => false,
                isCreateRevisionOpen: () => false,
                rejectNext(): void {},
                registerToTransactionApproved: _.noop,
                waitForResponsesToBeProcessed: asyncNoop,
                test: (): CSaveTestApi => undefined! as CSaveTestApi,
                onRevisionChange: _.noop,
                isUnappliedTransactionThresholdPassed: () => false,
                getUnappliedTransactionsData: () => ({count: 5, max: 5}),
                getUnappliedActionCountSinceLastRevision: () => 0,
                getUnappliedTransactionCountSinceLastRevision: () => 0,
                getActionCount: () => 0,
                cSaveErrors: {
                    convertToDSError: _.identity
                },
                isLocalTransaction: () => true,
                waitForCurrentPendingCsaves: asyncNoop
            }
        }
    }
}
